import { render, staticRenderFns } from "./coachneedList.vue?vue&type=template&id=061a3a10&"
import script from "./coachneedList.vue?vue&type=script&lang=js&"
export * from "./coachneedList.vue?vue&type=script&lang=js&"
import style0 from "./coachneedList.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports